/*
 * @Descripttion:
 * @Author: 老板说这个需求很简单
 * @Date: 2025-05-26 19:13:09
 * @LastEditTime: 2025-05-26 19:15:13
 * @LastEditors: sudo_rm_rf
 */

import longPress from './modules/longPress';
import dblclick from './modules/dblclick';
import hasPermi from './modules/hasPermi';
export default function directive(app: any) {
  app.directive('longPress', longPress).directive('dblclick', dblclick).directive('hasPermi', hasPermi);
}
